/**
 * Faz o parse dos campos JSON de indicador e monta a propriedade unificada "ficha".
 * Centraliza a lógica que antes era duplicada em AtoBusiness.tratarAto() e CertidaoBusiness.tratarAto().
 *
 * Extraído de IndicadorBusiness para evitar dependência circular:
 * AtoBusiness/CertidaoBusiness → IndicadorBusiness → Registro*Business → IndicadorAbstractService → AtoBusiness
 */
export const parseIndicadores = (a) => {
  a.indicador = typeof a.indicador === 'string' ? JSON.parse(a.indicador || false) : a.indicador;
  if (!a.indicador?.id) a.indicador = undefined;

  a.registroAuxiliar = typeof a.registroAuxiliar === 'string' ? JSON.parse(a.registroAuxiliar || false) : a.registroAuxiliar;
  if (!a.registroAuxiliar?.id) a.registroAuxiliar = undefined;

  a.indicadorReal = typeof a.indicadorReal === 'string' ? JSON.parse(a.indicadorReal || false) : a.indicadorReal;
  if (!a.indicadorReal?.id) a.indicadorReal = undefined;

  a.indicadorRealVinculado = typeof a.indicadorRealVinculado === 'string' ? JSON.parse(a.indicadorRealVinculado || false) : a.indicadorRealVinculado;
  if (!a.indicadorRealVinculado?.id) a.indicadorRealVinculado = undefined;

  a.indicadorRealDoiVinculado = typeof a.indicadorRealDoiVinculado === 'string' ? JSON.parse(a.indicadorRealDoiVinculado || false) : a.indicadorRealDoiVinculado;
  if (!a.indicadorRealDoiVinculado?.id) a.indicadorRealDoiVinculado = undefined;

  a.indicadorRealExternoVinculado = typeof a.indicadorRealExternoVinculado === 'string' ? JSON.parse(a.indicadorRealExternoVinculado || false) : a.indicadorRealExternoVinculado;
  if (!a.indicadorRealExternoVinculado?.id) a.indicadorRealExternoVinculado = undefined;

  // Ato do Livro 3 (RJ) carrega o vínculo complementar em indicadorRealVinculado; a ficha principal é o registro auxiliar.
  a.ficha = a.registroAuxiliar || a.indicadorReal || a.indicador;
  return a;
};
